import React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'
import CrossIcon from '../../../assets/Cross.svg'
import { StyledConfirmationButton, StyledConfirmationHeader, StyledConfirmationWrapper, StyledConfirmationMessage, StyledButtonBox } from './styled'
import getForcedMobile from '../../../utils/forceMobile'

interface DeleteSessionConfirmationProps {
  open: boolean
  sessionName?: string | null
  onClose: () => void
  onConfirmation: () => void
}

const DeleteSessionConfirmation: React.FC<DeleteSessionConfirmationProps> = ({ open, sessionName = null, onClose, onConfirmation }) => {
  const theme = useTheme()
  const forcedMobile = getForcedMobile()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const handleConfirmation = (): void => {
    onConfirmation()
  }

  const handleClose = (): void => {
    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <StyledConfirmationWrapper isMobile={isMobile || forcedMobile}>
        <StyledConfirmationHeader>
          <Typography fontSize={20} fontWeight={700}>
            Delete Chat?
          </Typography>
          <Box onClick={onClose}><img src={CrossIcon} alt='cross icon' style={{ cursor: 'pointer' }}/></Box>
        </StyledConfirmationHeader>
        <StyledConfirmationMessage>
          {sessionName !== '' ? `This will delete: ${sessionName}` : 'This will delete the selected session.'}
        </StyledConfirmationMessage>
        <StyledButtonBox>
          <StyledConfirmationButton
            variant='outlined'
            onClick={handleClose}
            color='primary'
          >
            Cancel
          </StyledConfirmationButton>
          <StyledConfirmationButton
            variant='contained'
            onClick={handleConfirmation}
          >
            Delete
          </StyledConfirmationButton>
        </StyledButtonBox>
      </StyledConfirmationWrapper>
    </Modal>
  )
}

export default DeleteSessionConfirmation
